import React from "react";
import HomePage from "./cv/home";
import HobbiesPage from "./cv/hobbies";
import LanguagesPage from "./cv/languages";
import CareerPage from "./cv/career";
import { HeaderMenu } from "./cv/menu";
import { useDarkMode } from "./theme";
import SkillsPage from "./cv/skills";
import PortfolioPage from "./cv/portfolio";
import "./i18n";

function App() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, toggleDarkMode] = useDarkMode();
  return (
    <React.Fragment>
        <HeaderMenu onThemeChange={toggleDarkMode} />
        <main>
          <HomePage />
          <CareerPage />
          <SkillsPage />
          <PortfolioPage />
          <LanguagesPage />
          <HobbiesPage />
        </main>
    </React.Fragment>
  );
}

export default App;
